import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`.endsWith("/")
    ? process.env.REACT_APP_API_URL
    : `${process.env.REACT_APP_API_URL}/`,
});

// before each request, read the latest token from localStorage so
// the axios instance doesn't hold a stale token from module init
api.interceptors.request.use(
  (config) => {
    const loggedUser = JSON.parse(localStorage.getItem("asu"));
    if (loggedUser && loggedUser.token) {
      const token = `Bearer ${loggedUser.token}`;
      // Envia ambos os cabeçalhos para máxima compatibilidade
      config.headers["Auth"] = token;
      config.headers["Authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// intercept responses to handle expired/invalid tokens
api.interceptors.response.use(
  (response) => {
    // Some APIs return 200 but with empty data or error message when token is invalid
    // Check if response looks like auth failure
    const data = response?.data;
    const url = response?.config?.url || "";

    // If response is empty string or looks like error, might be auth issue
    if (
      !url.includes("/login.php") &&
      (data === "" ||
        data === null ||
        (typeof data === "string" &&
          data.toLowerCase().includes("unauthorized")))
    ) {
      console.warn("Possible auth failure detected:", { data, url });
      localStorage.removeItem("asu");
      window.location.href = "/login";
    }

    return response;
  },
  (error) => {
    try {
      const status = error?.response?.status;
      const originalRequest = error.config || {};
      const url = originalRequest.url || "";

      console.error("API Error:", { status, url, error: error?.message });

      // If unauthorized (401 or 403), remove stored user and force navigation to login
      if (status === 401 || status === 403) {
        // avoid loops: if request already was to login endpoint, don't redirect
        if (!url.includes("/login.php")) {
          console.log(`${status} detected, logging out user`, { url });
          localStorage.removeItem("asu");
          // hard reload so contexts reinitialize and app shows login
          window.location.href = "/login";
        }
      }
    } catch (e) {
      console.error("Error in response interceptor:", e);
    }

    return Promise.reject(error);
  }
);

export { api };

export const createSession = async (username, password) => {
  return api.post("login.php", { withCredentials: true, username, password });
};

export const getPoints = async () => {
  return api.get("points.php");
};

export const getAlarms = async () => {
  return api.get("alarms.php");
};

export const getDetails = async (id, pointType, dateTime) => {
  return api.get("details.php", { params: { id, pointType, dateTime } });
};

export const update = async (id, columns) => {
  return api.patch("update.php", { id, columns });
};

export const updateConfig = async (id, receiveNotifications, timeInterval) => {
  const origin = navigator.userAgent;
  return api.patch("update-config.php", {
    withCredentials: true,
    id,
    receiveNotifications,
    timeInterval,
    origin,
  });
};

export const storeFCMToken = (userId, token) => {
  const origin = navigator.userAgent;
  return api.post("fcm-subscription.php", {
    withCredentials: true,
    userId,
    token,
    origin,
  });
};

export const getTheLatestDataSentToANA = async () => {
  return api.get("self-monitoring.php");
};
